import DialogComponent from "components/Dialog";

import { ReactComponent as TrashIcon } from 'icons/components/trash.svg';
import { ReactComponent as PlusIcon } from 'icons/buttons/plus.svg';

import './index.less';
import './themes/default.less';

export default class WorkHoursDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.sheet = {
            start: "08:00",
            end: "21:00"
        };

        this.digit = {
            0: "I.",
            1: "II.",
            2: "III.",
            3: "IV.",
        };

        this.defaultState = {
            ...this.state,
            workDays: [1, 2, 3, 4, 0],
            diffSheet: false,
        };

        this.state = { ...this.defaultState };
    }

    title = "schedule.clinicOpeningHours";

    show(info, hidCb) {
        const { shifts, clinicId } = info;
        this.state.shifts = shifts;
        this.state.clinicId = clinicId;
        this.state.workDays = Object.keys(shifts);
        this.hidCb = hidCb;
        super.show();
    }

    async save() {
        const { shifts, clinicId } = this.state;
        const dayOfWeek = this._config.dayOfWeek;

        const shiftItemList = [];
        dayOfWeek.forEach(day => {
            shiftItemList.push({
                dayOfWeek: day,
                timeFrom: "05:00:00",
                timeTo: "12:00:00"
            });
            shiftItemList.push({
                dayOfWeek: day,
                timeFrom: "12:00:00",
                timeTo: "19:00:00"
            });
        });

        const info = {
            domainId: clinicId,
            dateFrom: "2024-01-01",
            dateTo: "2024-12-31",
            shiftItemList: shiftItemList
        };

        if (shifts[0] && shifts[0][0] && shifts[0][0].settingId) {

            this.hide();

            this._helper.showLoading();
            await this._request.shifts.update(+shifts[0][0].settingId, info);
            this._helper.hideLoading();

            if (this.hidCb?.apply)
                this.hidCb(shifts);

        } else {
            this.hide();

            this._helper.showLoading();
            await this._request.shifts.addn([info]);
            this._helper.hideLoading();

            if (this.hidCb?.apply)
                this.hidCb(shifts);
        }

    }

    changeWorkDays(ind) {
        let { workDays } = this.state;

        if (workDays.includes(ind))
            workDays = workDays.filter(it => it !== ind);
        else
            workDays.push(ind);

        this.setState({ workDays });
    }

    addSheet() {
        const { shifts } = this.state;
        shifts.main.push(this.sheet);
        this.changeState("shifts", shifts);
    }

    deleteSheet(ind) {
        let { shifts } = this.state;
        shifts.main = shifts.main.filter((_, i) => i !== ind);
        this.changeState("shifts", shifts);
    }

    changeTime(ind, src, value) {
        const { shifts } = this.state;
        shifts.main.forEach((it, i) => {
            if (i === ind)
                it[src] = value;
        });
    }

    checkValue(value) {

        if (!value)
            return false;

        const parts = value.split(":");

        if (parts.length !== 2 || parts[0].length !== 2 || parts[1].length !== 2)
            return false;

        if (parseInt(parts[0]) >= 0 && parseInt(parts[0]) < 24 && parseInt(parts[1]) >= 0 && parseInt(parts[1]) < 60) {
            return true;
        }

        return false;
    }

    onBlurInput(i, src) {
        this[`${src}Time${i}`].validateCb(this.checkValue);
    }

    renderSheet(item, i) {
        const { start, end } = item;

        return (<div key={"sheet" + i} className="flex gap4 centerV">
            <div className="wrapText digit">{this.digit[i]}</div>
            <div className="wrapInput">
                {this.insertInput({
                    ref: el => this[`startTime${i}`] = el,
                    itemStyle: "flex1",
                    value: start,
                    validator: this._helper.inputValidators.formatTime,
                    onChange: this.changeTime.bind(this, i, "start"),
                    onBlur: this.onBlurInput.bind(this, i, "start"),
                    caption: ""
                })}
            </div>
            <div className="wrapText">{'\u2014'}</div>
            <div className="wrapInput">
                {this.insertInput({
                    ref: el => this[`endTime${i}`] = el,
                    itemStyle: "flex1",
                    value: end,
                    validator: this._helper.inputValidators.formatTime,
                    onChange: this.changeTime.bind(this, i, "end"),
                    onBlur: this.onBlurInput.bind(this, i, "end"),
                    caption: ""
                })}
            </div>
            <div className="wrapIcon trash" onClick={this.deleteSheet.bind(this, i)}>
                <TrashIcon />
            </div>
            <div className="wrapIcon plus" onClick={this.addSheet.bind(this)}>
                <PlusIcon />
            </div>
        </div>);
    }

    renderShortDays() {
        const { workDays } = this.state;
        const labels = this._helper.date.weekNamesShort.map(it => this._helper.string.capitalize(it));
        return (<div className="flex col gap8">
            <div className="text p2 grey">{this.tr("schedule.workDays")}</div>
            <div className="flex gap8 text p2">
                {labels.map((it, i) => (<div
                    className={`day rad12 ${workDays.includes(`${i}`) ? "active" : ""}`}
                    onClick={this.changeWorkDays.bind(this, i)}>
                    {it}
                </div>))}
            </div>
        </div>);
    }

    renderContent() {
        const { shifts, diffSheet } = this.state;

        const items = shifts && shifts[0] && shifts[0].length > 0 ? shifts : { 0: [{ start: "08:00", end: "22:00" }] };

        return (
            <div className="workHoursDialog content flex col gap16 pos rel">
                {this.renderShortDays()}
                <div className="sheetBlock rad8 flex col gap8">
                    <div className="text p2 grey">{this.tr("schedule.shifts")}</div>
                    {items[0].map((it, i) => this.renderSheet(it, i))}
                </div>
                {this.insertToggleSwitch({
                    checked: diffSheet,
                    label: "schedule.different",
                    onChange: this.toggleState.bind(this, "diffSheet")
                })}
            </div>
        );
    }
}
